export default __webpack_public_path__ + "static/media/FOTO-02.b8735ded.jpg";